import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import api from "@/services/api";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useMyContext } from "@/context/ContextApi";


/*

These values can be sent is params in Start Game:
mode        // "AI" | "LOCAL"
dimension   // "2D" | "3D"
playerType  // "EXISTING" | "ANON"
opponentId  // number | null

for example:
/pong?mode=LOCAL&dimension=3D&opponent=42
/pong?mode=LOCAL&dimension=2D&anon=true


*/

const CreateMatch = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [mode, setMode] = useState("AI");
  const [dimension, setDimension] = useState("2D"); // 2D | 3D
  const [opponent, setOpponent] = useState("");
  const [playerType, setPlayerType] = useState("EXISTING");
  const [opponentId, setOpponentId] = useState(null);

  const { fetchUser, currentUser, token } = useMyContext();


  const handleNext = async () => {
    try {
      // Validate LOCAL opponent before going forward
      if (step === 2 && mode === "LOCAL" && playerType === "EXISTING") {
        if (!opponent.trim()) {
          toast.error(t('createMatch_errorEnterUsername'));
          return;
        }else if (opponent.trim() == currentUser.username){
          // toast.error(t('createMatch_errorEnterUsername'));
          toast.error("You can play with you ...");
          return;
        }

        const response = await api.get(`/users/username/${encodeURIComponent(opponent)}`);
        setOpponentId(response.data.id);

        const oppId = response.data.id;
        startGame(oppId);
        return
      }

      if (step === 2 && mode === "LOCAL" && playerType === "ANON") {
      startGame();
      return;
    }

      if (step === 1) setStep(2);
    } catch (err) {
      if (err.response?.status === 404) {
        toast.error(t('createMatch_errorUserDoesNotExist'));
      } else {
        toast.error(t('createMatch_errorCheckingUser'));
      }
    }

  };

      const handleBack = () => {
      setStep(1);
    };


  const startGame = (oppId) => {
    const params = new URLSearchParams({
        mode,
        dimension: mode === "LOCAL" ? "2D" : dimension,
        ...(mode === "LOCAL" && playerType === "EXISTING" && oppId
          ? { opponent: oppId }
          : {}),
        ...(mode === "LOCAL" && playerType === "ANON" ? { anon: "true" } : {}),
      });
    navigate(`/pong?${params.toString()}`);
  };

  return (
    <section className="dark:bg-gray-900 min-h-screen flex items-center justify-center">
      <Card className="w-[450px]">
        <CardHeader>
          <CardTitle>{t('createMatch_title')}</CardTitle>
        </CardHeader>

        <CardContent className="space-y-6">
          {/* STEP 1: Choose AI or LOCAL */}
          {step === 1 && (
            <div className="space-y-4">
              <h2 className="font-semibold text-lg">{t('createMatch_selectMode')}</h2>

              <RadioGroup value={mode} onValueChange={setMode}>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="AI" id="ai" />
                  <Label htmlFor="ai">{t('createMatch_playVsAI')}</Label>
                </div>

                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="LOCAL" id="local" />
                  <Label htmlFor="local">{t('createMatch_playVsPlayer')}</Label>
                </div>
              </RadioGroup>

              <Button className="w-full" onClick={handleNext}>
                {t('createMatch_next')}
              </Button>
            </div>
          )}

          {step === 2 && mode === "AI" && (
  <div className="space-y-4">
    <h2 className="font-semibold text-lg">{t('createMatch_chooseGameType')}</h2>

    <RadioGroup value={dimension} onValueChange={setDimension}>
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="2D" id="2d" />
        <Label htmlFor="2d">{t('createMatch_2dGame')}</Label>
      </div>

      <div className="flex items-center space-x-2">
        <RadioGroupItem value="3D" id="3d" />
        <Label htmlFor="3d">{t('createMatch_3dGame')}</Label>
      </div>
    </RadioGroup>

    <div className="flex gap-2">
      <Button variant="outline" onClick={handleBack}>
        {t('createMatch_back')}
      </Button>
      <Button className="flex-1" onClick={startGame}>
        {t('createMatch_startGame')}
      </Button>
    </div>
  </div>
)}

         {step === 2 && mode === "LOCAL" && (
  <div className="space-y-4">
    <h2 className="font-semibold text-lg">{t('createMatch_choosePlayer')}</h2>

    <RadioGroup value={playerType} onValueChange={setPlayerType}>
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="EXISTING" id="existing" />
        <Label htmlFor="existing">{t('createMatch_existingUser')}</Label>
      </div>

      <div className="flex items-center space-x-2">
        <RadioGroupItem value="ANON" id="anon" />
        <Label htmlFor="anon">{t('createMatch_anonymousPlayer')}</Label>
      </div>
    </RadioGroup>

    {playerType === "EXISTING" && (
      <div className="space-y-2">
        <Label htmlFor="opponent">{t('createMatch_username')}</Label>
        <Input
          id="opponent"
          value={opponent}
          onChange={(e) => setOpponent(e.target.value)}
          placeholder={t('createMatch_usernamePlaceholder')}
        />
      </div>
    )}

    <div className="flex gap-2">
      <Button variant="outline" onClick={handleBack}>
        {t('createMatch_back')}
      </Button>
      <Button className="flex-1" onClick={handleNext}>
        {t('createMatch_startGame')}
      </Button>
    </div>
  </div>
)}
            <Link
              to="/"
              className="block text-center text-sm text-primary-600 hover:underline"
            >
            {t('createMatch_backToHomepage')}
          </Link>
        </CardContent>
      </Card>
    </section>
  );
};

export default CreateMatch;
